import { useEffect } from "react";
import { getSmaBucketStrategyLabel, isFundSma } from "../utility";

/** Keeps strategy aligned to SMA bucket label when an SMA fund is selected. */
export function useSmaBucketStrategySync({
  formData,
  setFormData,
  selectedFundMeta,
  managers,
  strategies,
}) {
  useEffect(() => {
    if (!formData.fund || !selectedFundMeta?.fundId) return;
    if (!isFundSma(selectedFundMeta.fundId, managers)) return;
    const label = getSmaBucketStrategyLabel(strategies);
    setFormData((prev) =>
      prev.strategy === label ? prev : { ...prev, strategy: label }
    );
  }, [formData.fund, selectedFundMeta?.fundId, managers, strategies]);
}
